import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getSummarySlice = createSlice({
    name: 'summary',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchSummary.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchSummary.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchSummary.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setAds, setStatus } = getSummarySlice.actions;
export default getSummarySlice.reducer;

export const fetchSummary = createAsyncThunk('/Summary/fetch', async ({ id }) => {
    const res = await axios.get(`${getBaseUrl()}/SummaryV3/${id}`);
    const data = res.data;
    return data
})